import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import EnrolmentLayout from '../../../../../common/hub/EnrolmentLayout';
import { OptionCard, OptionCardContent } from '../../../../../components/EnrolmentManagement/OptionCard';
import { IntentIntro } from '../../../../../components/IntentIntro';
import { useSelectEnrolmentModal } from '../../../../../components/Modals/SelectEnrolmentModal/SelectEnrolmentModal';
import { getActiveEnrolments } from '../../../../../selectors/hubSelector';
import { ELEMENT_TYPES } from '../../../../../types/hubEnums';
import type { Enrolment } from '../../../../../types/hubInterfaces';
import { PATH_HUB_CR_PAYMENT_QUERY } from '../../../../../util/pagePath';
import { usePageHeader } from '../../../../../v2/app-shell/usePageHeader';
import { useGetChoices } from './hooks';

function ManageServiceBillingAndPayments() {
  const activeEnrolments: Array<Enrolment> = useSelector(getActiveEnrolments);
  const accountDetails = useSelector(
    (state: { hubAccountPage: { accountDetails: { country: string } } }) => state.hubAccountPage.accountDetails
  );
  const history = useHistory();
  const { open, openModal, closeModal, SelectEnrolmentModal } = useSelectEnrolmentModal();
  const choices = useGetChoices(accountDetails?.country);
  const { setHeader } = usePageHeader();

  useEffect(() => {
    setHeader({
      label: 'Billing and payments',
      showIcon: false,
      showBackButton: true,
    });
  }, [setHeader]);

  return (
    <EnrolmentLayout
      sectionHeading="Home"
      mainHeading="Payments and billing"
      showEnrolmentStatus={false}
      showSummerModeEnrolmentStatus={false}
    >
      <SelectEnrolmentModal
        closeModal={closeModal}
        enrolmentLinkTo={(enrolment) => `${PATH_HUB_CR_PAYMENT_QUERY}?token=${enrolment.enrolmentId}`}
        open={open}
        state={{ headerLabel: 'Billing and payments' }}
      />
      <div className="flex min-h-screen flex-col px-5 pb-10 md:px-10">
        <div className="container mr-auto flex flex-col gap-y-5 px-0 pb-16 md:gap-y-10">
          <IntentIntro>How can we help you with payments and billing?</IntentIntro>
          <ul className="list-none">
            {choices.map(({ text, to, element, headerLabel }) => {
              if (element === ELEMENT_TYPES.BUTTON) {
                const linkTo = headerLabel
                  ? { pathname: to, search: `?token=${activeEnrolments[0].enrolmentId}`, state: { headerLabel } }
                  : `${to}?token=${activeEnrolments[0].enrolmentId}`;
                return (
                  <li key={text}>
                    <OptionCard
                      type={ELEMENT_TYPES.BUTTON}
                      onClickHandler={() => {
                        if (activeEnrolments.length === 1) {
                          history.push(linkTo);
                        } else {
                          openModal();
                        }
                      }}
                    >
                      <OptionCardContent>{text}</OptionCardContent>
                    </OptionCard>
                  </li>
                );
              }

              return (
                <li key={text}>
                  <OptionCard linkTo={to} type={element}>
                    <OptionCardContent>{text}</OptionCardContent>
                  </OptionCard>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </EnrolmentLayout>
  );
}

export default ManageServiceBillingAndPayments;
